module.exports = __webpack_public_path__ + "static/media/img_signin_super_admin.ce39525f.webp";